import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const commandes = [
  "Télécommande individuelle Somfy pour piloter un volet à distance",
  "Télécommande multi-canaux pour centraliser plusieurs volets",
  "Interrupteur mural filaire ou sans fil pour un contrôle local",
  "Application Somfy TaHoma pour piloter depuis votre smartphone",
  "Commande vocale via assistants domestiques connectés",
  "Programmation horaire automatique pour des scénarios personnalisés",
];

export default function Commandes() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Commandes, télécommandes et programmation
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              Une motorisation Somfy ne serait rien sans des commandes adaptées à votre mode de vie. Nous proposons l'installation de télécommandes individuelles ou multi-canaux, d'interrupteurs muraux filaires et sans fil, ainsi que de solutions connectées via l'application Somfy TaHoma. Chaque point de commande est programmé en fonction du protocole choisi : RTS pour une radio simple et fiable, ou io-homecontrol pour une domotique complète avec retour d'état.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              La programmation des commandes se fait directement sur place par nos techniciens. Nous appairons les télécommandes, réglons les fins de course haute et basse, et configurons les scénarios automatiques si vous le souhaitez. Vous pouvez ainsi programmer l'ouverture matinale et la fermeture du soir, activer la simulation de présence pendant vos vacances, ou même piloter vos volets par la voix grâce à l'intégration avec vos assistants connectés.
            </p>
            <ul className="space-y-3 mb-8">
              {commandes.map((cmd) => (
                <li key={cmd} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{cmd}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Modern%20French%20living%20room%20with%20a%20Somfy%20remote%20control%20and%20a%20smartphone%20app%20on%20a%20coffee%20table%20controlling%20a%20motorized%20white%20roller%20shutter%20warm%20interior%20lighting%20cozy%20atmosphere%20clean%20professional%20photography%20neutral%20tones%20Alsace%20home&width=700&height=520&seq=moto-cmd&orientation=landscape" alt="Télécommande Somfy et app sur bureau avec volet motorisé" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}